import { useEffect } from 'react'
import { useSetRecoilState } from 'recoil'
import eventBus from '../../../../services/eventBus'
import recoilStateUpdaters from '../../../../recoil/recoil.stateUpdaters.ts'
import parametersAtom from '../../parameters.atom.ts'

const useParameterEventsSubscriptions = () => {
    const setParamtersState = useSetRecoilState(parametersAtom)

    useEffect(() => {
        const createSub = eventBus.sub('parameter.created', (parameter) => {
            recoilStateUpdaters.itemCreated(setParamtersState, parameter)
        })

        const updateSub = eventBus.sub('parameter.updated', (parameter) => {
            recoilStateUpdaters.itemUpdated(setParamtersState, parameter)
        })

        const removeSub = eventBus.sub('parameter.deleted', (id) => {
            recoilStateUpdaters.itemDeleted(setParamtersState, id)
        })

        return () => {
            createSub()
            updateSub()
            removeSub()
        }
    }, [])
}

export default useParameterEventsSubscriptions
